"use client";

import { useTranslations } from "use-intl";

function FooterLegal() {
  const t = useTranslations("global.Footer");
  return (
    <div className="max-w-screen-2xl mx-auto text-xs mt-4 pt-4 flex flex-col gap-4 lg:flex-row lg:justify-between border-t">
      <ul className="list-none flex flex-row items-center justify-center gap-4 lg:justify-start">
        <li>&copy; 2025 OREME</li>
        <li>Photos &copy; CNRS Photothèque</li>
      </ul>
      <ul className="list-none flex flex-row items-center justify-center gap-4 lg:justify-start">
        <li>
          <a href="https://data.oreme.org/legal">{t("legal")}</a>
        </li>
        <li>
          <a href="https://data.oreme.org/legal/privacy">{t("privacy")}</a>
        </li>
      </ul>
    </div>
  );
}

export { FooterLegal };
